
const PageDataset = {
  defaultConfig: {

  },

  storageKey: 'mapped_allPagesByUrl',

  fixPathForHumanConsumption(path) {
    if (!path) {
      return "";
    }

    //rip off /en and other langues
    let result = path.replace('/en/', '/');
    //console.log(`\n${path}\n${result}`);
    return result;
  },

  init(allPagesByUrl) {

    const translations = allPagesByUrl.localization.fields.find(e => e.field === "key").translations;
    const pageViewData = allPagesByUrl.content;

    //map a reduced set from XA data
    const pv = pageViewData.map(p => {
      let path = this.fixPathForHumanConsumption(translations[p.key]);
      return {
        id: p.key,
        value: p.value,
        visits: p.visits,
        valuePerVisit: p.valuePerVisit,
        path: path,  //note: in the case of XA 'by url' dimenions, this is the page path.
        pageName: path,
        visitorProfile: p.visitorProfile,
        pageConfiguration: null,
        visitIndex: p.visitIndex,
        valueIndex: p.valueIndex
      };
    });

    this.storeData(pv)
  },

  storeData(data) {
    sessionStorage.setItem(this.storageKey, JSON.stringify(data));
  },

  getData() {
    let data = sessionStorage.getItem(this.storageKey);
    if (data) {
      return JSON.parse(data);
    }
    return null;
  }
};

export default PageDataset;


// WEBPACK FOOTER //
// ./src/components/PageDataset.js